import { localisedValue } from "utils"

const projectTypeLocationTransformer = data => {
  let tempArray = [{ id: -1, breadcrumbTitle: "All", children: [] }, ...data]
  return recursiveTransform(tempArray)
}

const recursiveTransform = data => {
  return data?.map(item => {
    return {
      ...item,
      value: item?.id,
      title: localisedValue({ object: item, key: "breadcrumbTitle" }),
      children: item?.children && item?.children.length > 0 ? recursiveTransform(item?.children) : [],
    }
  })
}

export default projectTypeLocationTransformer
